<div class="rx-intuitive-art-treatment-viewlist-item">
	<div class="rx-intuitive-art-treatment-viewlist-item__leading-container">
		<div class="rx-intuitive-art-treatment-viewlist-item__title-and-treatment">
			<div class="rx-intuitive-art-treatment-viewlist-item__title">
				{{ 'ToothEditor.ToothNumberHash' | translate }}{{ item.toothNumberInSystem }}
			</div>
			<div class="rx-intuitive-art-treatment-viewlist-item__treatment">
				<rx-intuitive-art-indication-button [indication]="item.treatment.integrity" [asLabel]="true" />
				<rx-intuitive-art-indication-button
					*ngFor="let definition of item.treatment.definitions"
					[indication]="definition"
					[asLabel]="true"
				/>
			</div>
		</div>
	</div>
	<div class="rx-intuitive-art-treatment-viewlist-item__trailing-container">
		<button
			*ngIf="!chartReadOnly"
			tlkButton
			variant="ghost"
			size="l"
			[attr.aria-label]="'ToothEditor.Delete' | translate"
			[disabled]="!item.canReset"
			(click)="onResetClicked($event)"
		>
			<tlk-delete-icon />
		</button>
	</div>
</div>
